import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  CancelTokenStatic,
} from 'axios';
import responseInterceptor from './response-interceptor';

interface CustomAxiosInstance extends AxiosInstance {
  CancelToken?: CancelTokenStatic;
  isCancel?(value: any): boolean;
}

const AxiosClient: CustomAxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_BASE_API_URL!!,
});

AxiosClient.CancelToken = axios.CancelToken;
AxiosClient.isCancel = axios.isCancel;

AxiosClient.interceptors.request.use((config: AxiosRequestConfig) => {
  // One sample custom header referring to autorisation secret provided
  config.headers!!.Authorization = `bearer ${localStorage.getItem(
    'api-token',
  )}`;

  return config;
});

AxiosClient.interceptors.response.use(
  (response) => response,
  responseInterceptor(AxiosClient),
);

export default AxiosClient;
